<!-- 推荐位管理 recommend-->
<template>
  <div class="recommend">
    <div class="form_header">
      <el-form ref="form" :model="userform" label-width="80px">
        <div class="form_list">
          <el-form-item label="状态：">
            <el-select v-model="userform.status" placeholder="请选择状态">
              <el-option label="停用" value="0"></el-option>
              <el-option label="正常" value="1"></el-option>
            </el-select>
          </el-form-item>
          <div class="btn_box">
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button>取消</el-button>
          </div>
        </div>
      </el-form>
      <div>
        <!-- <el-button type="primary" icon="el-icon-upload2">导出</el-button> -->
        <el-button type="primary" icon="el-icon-plus" @click="addPoints">新增</el-button>
      </div>
    </div>
    <div class="user_list">
      <el-table :data="recommList" style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="rowStyle" :cell-style="rowStyle">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="pc_img" label="PC图片"></el-table-column>
        <el-table-column prop="h5_img" label="APP图片"></el-table-column>
        <el-table-column prop="integrals" label="积分"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">停用</span>
            <span v-if="scope.row.status==1">正常</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">复制</el-button> -->
            <el-button type="text" size="small" @click="editbox(scope.row)">编辑</el-button>
            <el-button @click="removesize(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy_box">
      <el-pagination @current-change="handleCurrentChange" background prev-text="上一页" next-text="下一页" :current-page="currentindex" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totals"></el-pagination>
    </div>
    <!-- 新增--编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="pop_up">
      <el-form :model="Edform" :rules="rules" label-width="100px">
        <el-form-item label="标题">
          <el-input v-model="Edform.title"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="Edform.model" show-password></el-input>
        </el-form-item>
        <el-form-item label="PC图片">
          <el-upload action list-type="picture-card" :http-request="(file)=>handaddimg(file,1)" accept=".png, .jpg, .jpeg" :limit="1" :file-list="Edform.fileList1" :class="{ hideUpload: Edform.fileList1.length > 0 }" :on-remove="(file)=>handleRemove(file,1)">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="APP图片">
          <el-upload action list-type="picture-card" :http-request="(file)=>handaddimg(file,1)" accept=".png, .jpg, .jpeg" :limit="1" :file-list="Edform.fileList2" :class="{ hideUpload: Edform.fileList2.length > 0 }" :on-remove="(file)=>handleRemove(file,1)">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="积分">
          <el-input v-model="Edform.integrals" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pop_up = false">取 消</el-button>
        <el-button type="primary" @click="SubmitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { recommendlists } from "../../api/system.js";
import { uploadimg, hostimg } from "../../api/comm.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      userform: {
        status: ""
      },
      Edform: {
        fileList1:[],
        fileList2:[],
      },
      recommList: [
        {
          name: "9f30002",
          num: "1000",
          name1: "启用"
        }
      ],
      currentindex: 1,
      pageSize: 10,
      totals: 100,
      titleName: "新增",
      pop_up: false,
      rules: {
        reason: [{ required: true, message: "请输入拒绝原因", trigger: "blur" }]
      },
      domainUrl: ""
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    rowStyle() {
      return { textAlign: "center" };
    },
    //实时域名
    domainName() {
      hostimg().then(res => {
        // console.log(res);
        if (res.code == 200) {
          this.domainUrl = res.data.url;
          this.recommenddata();
        }
      });
    },
    //推荐位列表
    recommenddata() {
      let data = {
        page: this.currentindex,
        page_size: this.pageSize,
        status: this.userform.status
      };
      recommendlists(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.recommList = res.data.data;
          this.totals = res.data.total;
        }
      });
    },
    //分页切换
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentindex = val;
    },
    //搜索
    onSubmit() {
      // console.log(this.userform);
    },
    // 新增--弹窗
    addPoints() {
      this.titleName = "新增";
      this.pop_up = true;
    },
    //编辑弹窗
    editbox(e) {
      this.titleName = "编辑";
      this.pop_up = true;
      // console.log(e);
    },
    //弹窗提交
    SubmitAdd() {
      // console.log(this.Edform);
    },
    //选中
    handleSelectionChange(val) {
      // console.log(val);
    },
    //删除
    removesize(e) {
      // console.log(e);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.domainName();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.recommend {
  padding: 20px 30px 0;
  .form_header {
    display: flex;
    justify-content: space-between;
    .btn_box {
      margin-left: 20px;
    }
  }
  .form_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .user_list {
    padding: 20px 0;
  }
}
</style>
<style lang='scss'>
.recommend {
  .form_header {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
  }
}
</style>